/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';
const Accordions = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 * @param {jQuery} $dom     for any jQuery selectors    - example: $domMenu: $('.js-menu')
	 * @param {string} class    for any class strings       - example: classActive: 'is-active'
	 */

	$domAccordionsItem: $('.js-accordion-item'),
	classOpenAccordion: 'open',

	/**
	 * @description Initialize
	 */
	init: function() {
		this.accordionsToggleOpen();
		this.observeAccordionItems();
	},

	accordionsToggleOpen: function() {
		const faqItems = this.$domAccordionsItem.toArray();

		faqItems.forEach(item => {
			$(item).find('.js-accordion-question').on('click', () => {
				// Close all other open items
				faqItems.forEach(i => {
					if (i !== item) {
						$(i).removeClass(this.classOpenAccordion);
					}
				});

				// Toggle the clicked item
				$(item).toggleClass(this.classOpenAccordion);
			});
		});
	},

	observeAccordionItems: function() {
		const observer = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					$(entry.target).addClass('transition-in-view');
					observer.unobserve(entry.target); // Stop observing after triggering once
				} else {
					$(entry.target).removeClass('transition-in-view');
				}
			});
		}, {
			root: null,
			rootMargin: '0px',
			threshold: 1,
		});

		this.$domAccordionsItem.each(function() {
			observer.observe(this);
		});
	}
};

export default Accordions;

